export const INBOX_API_KEY = 'inbox';

export enum ERROR_CODES {
  STATE_CHANGED = 'STATE_CHANGED',
  NOT_FOUND = 'NOT_FOUND',
  DELETED = 'DELETED',
  NOT_ALLOWED = 'NOT_ALLOWED',
}

export type ResponseError = {
  status: boolean;
  error: {
    'error-code': ERROR_CODES;
    message: string;
  };
};

export function isResponseError(obj: any): obj is ResponseError {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'status' in obj &&
    'error' in obj &&
    typeof obj.error === 'object' &&
    obj.error !== null &&
    'error-code' in obj.error &&
    'message' in obj.error
  );
}
